export interface UserDetailsModel {
  userId: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  avatar: string;
  oldPassword: string;
  newPassword: string;

  hasUpdateError: boolean;
  updateErrorMessage: string;

  // Intercom settings
  messengerSecurity: MessengerSecurity;
  intercomUserHash: string;
}

export enum MessengerSecurity {
  None = 0,
  IdentityVerification = 1,
  Jwt = 2
}
